if (!customElements.get("set-product-gallery")) {
  customElements.define(
    "set-product-gallery",
    class extends HTMLElement {
      connectedCallback() {
        this.initializeSwiper();
      }

      disconnectedCallback() {
        window.clearTimeout(this.swiperTimer);
        this.gallerySwiper?.destroy(true, true);
        this.thumbnailsSwiper?.destroy(true, true);
      }

      initializeSwiper(attempt = 0) {
        if (this.gallerySwiper) return;

        if (typeof window.Swiper !== "function") {
          if (attempt < 40) {
            this.swiperTimer = window.setTimeout(
              () => this.initializeSwiper(attempt + 1),
              150,
            );
          }
          return;
        }

        const gallery = this.querySelector(".set-product__gallery-main");
        const thumbnails = this.querySelector(".set-product__thumbs");
        const pagination = this.querySelector(
          ".set-product__gallery-pagination",
        );

        if (!gallery) return;

        if (thumbnails) {
          this.thumbnailsSwiper = new window.Swiper(thumbnails, {
            slidesPerView: "auto",
            spaceBetween: 10,
            freeMode: true,
            watchSlidesProgress: true,
          });
        }

        this.gallerySwiper = new window.Swiper(gallery, {
          slidesPerView: 1,
          speed: 500,
          loop: false,
          pagination: pagination
            ? {
                el: pagination,
                clickable: true,
              }
            : undefined,
          thumbs: this.thumbnailsSwiper
            ? {
                swiper: this.thumbnailsSwiper,
              }
            : undefined,
        });
      }
    },
  );
}
